
import formatNumber from 'format-number';

const formatToUSD = (value: string|number|undefined|null) => {
  if (value === undefined) return '';
  if (value === null) return '';
  if (typeof value === 'string') return formatNumber({prefix: '$', round: 2})(parseFloat(value));
  return formatNumber({prefix: '$', round: 2})(value);
}

export default formatToUSD;
